import { useOrderSearchForm } from '@euler/app/flows/search/context';
import { FormGroup } from '@euler/components/form';
import { Input } from '@euler/components/form/Input';
import { memo } from 'react';

export const CustomerNameField = memo(() => {
  const { form } = useOrderSearchForm();
  return (
    <FormGroup label="车主姓名">
      <Input
        value={form.customerName.value ?? ''}
        placeholder="按车主姓名搜索"
        clearButtonMode="always"
        onChangeText={form.customerName.update}
      />
    </FormGroup>
  );
});
